<template>
    <div class="parkMap">
        <servicesList></servicesList>
        <div class="map_content">
            <!--<div id="parkImg">
                <div class="zoomableContainer" >
                    <img id="imageFullScreen" src="../../assets/images/service/map_bg.jpg" >
                </div>
            </div>

            <div id="parkImg_detail" >
                <div class="zoomableContainer" >
                   <img id="imageFullScreen1" src="../../assets/images/service/yuyui.jpg" >
                </div>
            </div>-->
            <div class="map_img">
                <img :src="imgSrc" alt="园区地图" draggable="false" preview="1" >
            </div>
            <ul class="icons_lists">
                <li @click="mapImgSrc()">{{ $t(mapName)}}</li>
                <li @click="downloadImage()">{{$t('map_download')}}</li>
            </ul>
        </div>
    </div>
</template>
<script>
    import servicesList from '../../components/services/servicesList';
    export default {
        name: "parkMap",
        components:{
           servicesList
        },
        data:function(){
          return {
              imgSrc:'static/img/map_bg.jpg',
              mapName:'service.map_title',
              num:0
          }
        },
        created(){
          /*  this.$store.commit("set_current_index", 2);*/
            this.$store.commit("set_current_index", 1);
            this.$store.commit("set_current", 5);
            this.$store.commit("set_title", 'nav.service');
         },
        methods :{
            downloadImage (){
                // 将图片的src属性作为URL地址
                let url = this.imgSrc;
                console.log(url);
                var a = document.createElement('a');
                var event = new MouseEvent('click');
                a.download = this.mapName ;
                a.href = url;
                a.dispatchEvent(event);
            },
            mapImgSrc(){
               this.num ++;
               console.log(this.num);
               if(this.num %2 ==0){
                   this.imgSrc='static/img/map_bg.jpg';
                   this.mapName='service.map_title';
               }else {
                   this.imgSrc='static/img/yuyui.jpg';
                   this.mapName='tourist_map';
               }

            }


        },

    }
</script>

<style scoped lang="less">
    @import "../../assets/less/common.less";
    .parkMap {
        background: @bg;
        width:@width;
        .map_content {
            padding: 20px;
            .box-sizing;
            width:@width;
            @media (max-width: 411px) {
                min-height: 572px;
            }
        }
        .map_img {
            width:@width;
            /*height:398px ;*/
            .box-sizing;
            padding: 8px;
            .border-radius(10px);
            .border(1px;solid;@word;);
            background: @font-primary;
            /*position: relative;*/
            img {
                .img;
            }
         /*   &:after {
                content: '';
                bottom: 8px;
                right:8px;
                width: 30px;
                height: 30px;
                background: url(../../assets/images/service/service_sprite.png) no-repeat 0  0px;
                background-size: 33px auto;
            }*/
        }
        .icons_lists {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 30px 0;
            li {
                width: 40%;
                .btn;
                @media (min-width: 768px){
                    width: 27%;
                }
               &:first-child {
                   margin-right: 20px;
               }
                &:last-child {
                    background: @subject_color;
                }
            }
        }
    }
   /* #parkImg ,#parkImg_detail{
        position: fixed;
        background: rgba(0,0,0,.3);
        z-index: 1100;
        width: 100vw;
        height: 100vh;
        display: none;
    }

    .zoomableContainer {
        overflow: hidden;
        position: fixed;
        top: 5%;
        left:25% ;
        width: 900px;
        height:800px;
    }

    #imageFullScreen,#imageFullScreen1{
        transition: all 0s ease-out 0s;
        transform: translate3d(160px, 2px, 0px) scale3d(0.44, 0.44, 1);
        cursor: default;
        transform-origin: 0 0 0;
    }*/

</style>
